module.exports = __webpack_public_path__ + "static/media/SuisseIntl-SemiBold-WebS.37cdcc3e.eot";